import API from 'services/api';
import { serializeCustomMetric } from './utils';

const api = new API();
const CUSTOM_METRICS_URL = '/api/custom-metrics';

const fetchFromApi = (url, options = {}) => {
    const config = {
        method: options.method || 'GET',
        credentials: 'include',
    };

    if (options.body) {
        config.body = options.body;
    }

    if (options.params) {
        config.params = options.params;
    }

    return new Promise((resolve, reject) => {
        api.getJson(url, config)
            .then(response => {
                if (response.status !== 0) {
                    return reject(response.value);
                }
                return resolve(response.value);
            })
            .catch(reject);
    });
};

export const getCustomMetrics = () => fetchFromApi(CUSTOM_METRICS_URL);

export const getMetricsDimensions = () => fetchFromApi(`${CUSTOM_METRICS_URL}/dimensions`);

export const getExpressionOperators = () => fetchFromApi(`${CUSTOM_METRICS_URL}/expression_operators`);

export const getDisplayFormats = () => fetchFromApi(`${CUSTOM_METRICS_URL}/field_types`);

export const getAllMetrics = () => fetchFromApi('/api/users/enrichment_fields_and_all_metrics');

export const getReferenceTables = () => fetchFromApi('/reference/api/all');

export const getCohortPeriods = () =>
    fetchFromApi('/api/cohort_metrics', { params: { is_api_call: false } }).then(({ periods }) => periods);

export const getCustomMetricsPageData = () =>
    Promise.all([
        getMetricsDimensions(),
        getExpressionOperators(),
        getDisplayFormats(),
        getCustomMetrics(),
        getAllMetrics(),
        getReferenceTables(),
        getCohortPeriods(),
    ]).then(([dimensions, expressionOperators, displayFormats, customMetrics, allMetrics, refTables, periods]) => ({
        dimensions,
        expressionOperators,
        displayFormats,
        customMetrics,
        allMetrics,
        refTables,
        periods,
    }));

export const saveCustomMetric = metric => {
    const url = metric.oldName ? `${CUSTOM_METRICS_URL}/${metric.oldName}` : CUSTOM_METRICS_URL;
    return fetchFromApi(url, { method: 'POST', body: serializeCustomMetric(metric) });
};

export const deleteCustomMetric = metricName =>
    fetchFromApi(`${CUSTOM_METRICS_URL}/${metricName}`, { method: 'DELETE' });
